/**
 * iinkJS用の基本コントローラ
 * ※今のところ共通処理等特にないが、これを利用してコントローラを拡張する。
 * ※Angularモジュール化しても良かったが、別途全コントローラの appjs への登録記述が必要なのでやめた
 * 
 * ↓の呼び出しが定義済み。必要なら処理を実装したクラスを
 * createHandWritingDirective(option)のoption.controller に渡す。
 * 
 * $scope.onDestroy = function(element) {}
 * $scope.onMouseDown = function(e) {}
 * $scope.onMouseUp = function(e) {}
 * $scope.onMouseMove = function(e) {}
 * $scope.onMouseLeave = function(e) {}
 * $scope.onExported = function(e) {}// e.detail に結果が入っている
 * 
 * @param {*} $scope 
 */
export default function($scope) {
  // $scope.onDestroy = function(element) {}
  // $scope.onMouseDown = function(e) {}
  // $scope.onMouseUp = function(e) {}
  // $scope.onMouseMove = function(e) {}
  // $scope.onMouseLeave = function(e) {}

  /**
   * 入力済みだが認識APIからの応答待ちの状態で Editor の DOM が削除された場合、
   * デストラクタで削除できないので、デストラクタを明示的に呼べるようにした。
   * 処理が終わったらデストラクタを呼ぶ。
   * @param {Event} e 
   */
  $scope.onExported = function(e) {
    $scope.exportTimer = null;
    if ($scope.destroyCallback && $scope.link) {
      $scope.link.onDestroy($scope, $scope.element, $scope.attrs);
    }
  }

  /**
   * 描画状態保持用
   */
  $scope.drawing = {
    flag: false,
  };

  /**
   * 認識エンジンへのAPI発行タイマー
   */
  $scope.exportTimer = null;

  /**
   * onMouseDown: 描画フラグ初期化、API発行タイマー解除
   */
  $scope.onMouseDown = function(e) {
    // 描画中フラグ
    $scope.drawing.flag = true;
    isDrawing = true;
    // API発行タイマー解除
    if ($scope.exportTimer) {
      clearTimeout($scope.exportTimer);
      $scope.exportTimer = null;
    }

    e.preventDefault();
    e.stopPropagation();
  }

  /**
   * onMouseUp: 描画フラグクリアし、API発行タイマーを駆動
   */
  $scope.onMouseUp = function(e) {
    if (! $scope.drawing.flag) {
      return;
    }
    // 描画中フラグ
    $scope.drawing.flag = false;
    // API発行タイマー
    $scope.setTimer(e);

    e.preventDefault();
    e.stopPropagation();
  }

  /**
   * onMouseLeave: 描画中だったらMouseUpと同じ処理をする
   * @param {*} e 
   */
  $scope.onMouseLeave = function(e) {
    if ($scope.drawing.flag) {
      $scope.onMouseUp(e);
    }
  }

  /**
   * (N)ms後にAPIを発行するタイマーの生成
   * @param {*} e 
   */
  $scope.setTimer = function(e) {
    $scope.exportTimer = setTimeout(
      $scope.demandExport, // $scope.editor.export_,//これはNG
      $scope.delay
    );
    
    $scope.beforeExportApi();// 削除ボタン押下をさせないために必要
  }

  /**
   * API発行
   */
  $scope.demandExport = () => {
    $scope.beforeExportApi();
    $scope.editor.export_();
  }

  /**
   * API発行直前の処理
   */
  $scope.beforeExportApi = () => {}

  // $scope.$on() で登録したイベントは、返却される function で登録解除するのでその返却関数を貯める必要がある。
  $scope.unregistFuncs = [];
  // $scope.$on() の代わりに呼ぶこと。
  $scope.addEventListener = (eventName, f) => {
    $scope.unregistFuncs.push($scope.$on(eventName, f))
  }
  $scope.onDestroy = () => {
    for (let f = $scope.unregistFuncs.pop(); typeof f === 'function'; f = $scope.unregistFuncs.pop()) {
      f();
    }
  }
}
